



















































































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component } from 'vue-property-decorator';
import {
  CheckIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  CrosshairIcon,
  FilterIcon,
  GridIcon,
  XIcon,
} from 'vue-feather-icons';
import { BusinessPlanGoalsFilter, DateFilter, IFivGoal } from 'admiral-core';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';
import GoalFilterComponent from '@/components/filters/GoalFilter.vue';
import { PreferencesAction } from '@/store/PreferencesModule';
import { BusinessPlanApi } from '@/services/BusinessPlanApi';
import Multiselect from 'vue-multiselect';
import GoalSelect from '@/components/common/selects/GoalSelect.vue';

@Component({
  components: {
    GoalSelect,
    'goal-filter': GoalFilterComponent,
    FilterIcon,
    CrosshairIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    Multiselect,
    CheckIcon,
    XIcon,
    GridIcon,
  },
})
export default class BusinessPlanPlusFilterComponent extends mixins(FilterMixin) {
  filter: BusinessPlanGoalsFilter = {
    goals: [],
  };

  selectableGoals: IFivGoal[] = [];

  get isDefaultFilter() {
    return JSON.stringify(this.filter.goals) === JSON.stringify(this.selectableGoals);
  }

  async changedGoals() {
    await this.$store.dispatch(
      `PreferencesModule/${PreferencesAction.setBusinessPlanPlusGoalsFilter}`,
      this.filter,
    );
  }

  async mounted() {
    try {
      const response = await BusinessPlanApi.getLatestBusinessPlanReportGoals({
        user: this.user,
      });

      this.selectableGoals = response.data;

      this.filter = await this.$store.getters['PreferencesModule/getBusinessPlanPlusGoalsFilter'];

      if (this.filter?.goals?.length === 0) {
        this.filter.goals = [...this.selectableGoals];
        await this.$store.dispatch(
          `PreferencesModule/${PreferencesAction.setBusinessPlanPlusGoalsFilter}`,
          this.filter,
        );
      }
      this.filter = await this.$store.getters['PreferencesModule/getBusinessPlanPlusGoalsFilter'];
    } catch (e) {
      console.log(e);
    }
  }
  get selectedGoals(): IFivGoal[] {
    return this.businessPlanGoalsFilter.goals || [];
  }

  get businessPlanGoalsFilter(): BusinessPlanGoalsFilter {
    return this.$store.getters[`PreferencesModule/getBusinessPlanPlusGoalsFilter`];
  }

  updateGoalFilter(goals: IFivGoal[]) {
    this.filter.goals = [...goals];
    this.updateFilter();
  }

  selectedFilterString() {
    const str = `${this.filter.goals.length} ausgewählte Ziele`;

    return str;
  }

  async resetFilter() {
    this.filter = {
      goals: [],
    };

    const response = await BusinessPlanApi.getLatestBusinessPlanReportGoals({
      user: this.user,
    });

    this.selectableGoals = response.data;

    this.filter.goals = this.selectableGoals;
    await this.updateFilter();
  }

  async updateFilter() {
    await this.$store.dispatch(
      `PreferencesModule/${PreferencesAction.setBusinessPlanPlusGoalsFilter}`,
      this.filter,
    );
  }

  isSelected(id: string) {
    return this.filter.goals.find((goal: IFivGoal) => goal.id === id);
  }
}
